import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import { getBalance } from "../../../api/currency";
import { useCurrencyFormat } from "../../../hooks/useCurrencyFormat";
import { AuthContext } from "../../../context/AuthContext";
import jwt_decode from "jwt-decode";
import { useKyc } from "../../../hooks/useKyc";
import { AlertModalKyc } from "../../../components/AlertModalKyc/AlertModalKyc";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CallToAction from "../../CallToAction/index";

export function useHome() {
  const MySwal = withReactContent(Swal);

  const { setLoading,checkToken } = useContext(AuthContext);

  const route = useNavigate();
  const [saldo, setSaldo] = useState(0);
  const [limite, setLimite] = useState(0);
  const [pendiente, setPendiente] = useState(0);
  const { formatWithCurrencyISO } = useCurrencyFormat();

  async function _getBalance(loading = true) {
    checkToken()
    let _return = false;
    setLoading(loading);
    try {
      const dataGetBalance = await getBalance();
      setLoading(false);
      const res = dataGetBalance.data;
      if (res.code == "PROCESS_OK") {
        setSaldo(res.data.balances.availableAmount);
        setLimite(res.data.balances.limitAmount);
        setPendiente(res.data.balances.dueDate);
      }
    } catch (error) {
      setLoading(false);
      const res = error.response.data;
      if (res.code == "NOT_FOUND") {
        // Swal.fire({
        //   title: "Código incorrecto",
        //   text: "",
        //   imageUrl: require("../../components/assets/images/advertir.png"),
        //   imageWidth: 150,
        //   imageHeight: 150,
        //   confirmButtonColor: "#fd6e0d",
        // });
      }
    }
    return _return;
  }
  let textSaldo = `${formatWithCurrencyISO(saldo, "484")}`;
  let textLimite = `${formatWithCurrencyISO(limite, "484")}`;
  let textPendiente = `${formatWithCurrencyISO(pendiente, "484")}`;

  const spendNavigation = () => {
    route("/MainScreen");
  };

  const { refreshToken } = useKyc();

  const isRegisteredUser = async (action) => {

    let token = await localStorage.getItem("token");
    setLoading(true)
    if (!token) {
      action();
      setLoading(false)

      return;
    } {
      let tokenDecode = jwt_decode(token);
      if (
        tokenDecode.kycStatus == "REJECTED" ||
        tokenDecode.kycStatus == "IN_PROCESS" ||
        tokenDecode.kycStatus == "PENDING"
      ) {
        await refreshToken();
        token = await localStorage.getItem("token");
        tokenDecode = jwt_decode(token);
        constShowValidationModal(tokenDecode.kycStatus, action);
        setLoading(false)
        return;
      }

      if (tokenDecode.kycStatus) {
        if (
          tokenDecode.kycStatus != "COMPLETED" &&
          tokenDecode.kycStatus != "IN_REVIEW"
        ) {
          Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: "Rellena tu kyc",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          })
          setLoading(false)
          return;
        } else {
          setLoading(false)
          action();

        }
      } else {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Rellena tu kyc",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
        return;
      }
    }


  };
  const constShowValidationModal = (status, action) => {
    switch (status) {
      case "REJECTED":
        MySwal.fire({
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          html: <AlertModalKyc type="REJECTED" onChange={() => {
            MySwal.close()
          }} />,
        });
        break;

      case "IN_PROCESS":
        MySwal.fire({
          showCloseButton: true,
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          html: <AlertModalKyc type="IN_PROCESS" onChange={() => {
            MySwal.close()
          }} />,
        });
        break;

      case "PENDING":
        MySwal.fire({
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          showCloseButton: true,
          html: <AlertModalKyc type="PENDING" onChange={() => {
            MySwal.close()
            route("/MenuKycScreen");
          }} />,
        });
        break;

      case "COMPLETED":
        action()
        break;

      default:
        break;
    }
  };

  const getStatusByToken = ()=>{
    let token = localStorage.getItem("token");
    let tokenDecode = jwt_decode(token);
    return tokenDecode.kycStatus;
  }

  const getUserCallToAction = ()=>{
    //Get user call to action


    //Retrun call to action
   let callToAction = {
        enabled:false,
        title:"TITLE",
        subtitle: "SUBTITLE",
        button:{
          visible:true,
          title:"TRY ME",
          action : ()=>{route('/')}

        }
    } 

    return callToAction
  }


  const setCallToAction = ()=>{

    let status = getStatusByToken();

    if(status == 'PENDING'){
      return (<CallToAction.KYC.Pending/>);
    }

    if(status == 'IN_PROCESS'){
      return (<CallToAction.KYC.InProcess/>);
    }

    if(status == 'REJECTED'){
      return (<CallToAction.KYC.Rejected/>);
    }

    //Check if exista a camping of call to action.
    let callToAction = getUserCallToAction()
    if(callToAction.enabled == true){
      return (<CallToAction.Base title = {callToAction.title} subtitle={callToAction.subtitle} button={{visible:callToAction.button.visible, title:callToAction.button.title, action:callToAction.button.action}}/>);
    }

    return null

  }


  return {
    textLimite,
    textSaldo,
    saldo,
    textPendiente,
    _getBalance,
    spendNavigation,
    isRegisteredUser,
    refreshToken,
    route,
    setCallToAction
  }
}